export function renderOptions(parts, level = 0) {
    // Guard clause: return empty array if parts is not a valid array
    if (!parts || !Array.isArray(parts)) {
        return [];
    }

    return parts.flatMap(part => {
        return [
            <option key={part.id} value={part.id}>
                {`${'—'.repeat(level)} ${part.name}`}
            </option>,
            ...renderOptions(part.children, level + 1)
        ];
    });
}
